import { useState } from "react";
import {
  CheckIcon,
  ChevronUpDownIcon,
  PlusIcon,
  XMarkIcon,
} from "@heroicons/react/20/solid";
import { Combobox } from "@headlessui/react";
import {
  addFilters,
  classNames,
  disabledIfFieldChecker,
  extractFromObject,
  getFromAPI,
} from "../../../utils/helperFuctions";
import { useEffect } from "react";
import { config } from "../../../utils/config";
import { useSelector } from "react-redux";
import { fetchDataToDropDown } from "../../../utils/helperFuctions";

function InputDropDown({
  label,
  name,
  id,
  defaultValue,
  handleChange,
  data,
  err,
  returnID,
  returnObject,
  lazyloadUrl,
  disabled,
  showParameter,
  placeholder,
  lazyloadParam,
  lazyloadParam2,
  lazyloadParam3,
  concat,
  concatBy,
  addNew,
  handleCreate,
  defaultsTo,
  hide,
  required,
  filters,
  lazyloadFieldChange,
  exclude,
  lazyloadParamName,
  removeElementIfPreviouslyAdded,
  fieldParentName,
  refetchOnSave,
  isSaving,
  setIsSaving,
  disabledIfField,
  displayTextOnly,
  returnDataAsIs,
  editId,
  defaultOnNew,
  isFieldReadOnly,
  disableXButton,
  fromPopup,
  actionType,
  disableOnAction,
  disableEditForNonAdmin,
  currentRole,
  formType,
  currentFieldsOverride,
  nameTransformer,
}) {
  function parseOrReturn(str) {
    const isInteger = /^[0-9]+$/.test(str);
    return isInteger ? parseInt(str) : str;
  }

  const [query, setQuery] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const index = data.findIndex(
    (field) =>
      field.name ===
        (typeof defaultValue === "object"
          ? defaultValue?.name
          : defaultValue) ||
      field.id ===
        (typeof defaultValue === "object"
          ? defaultValue?.id
          : parseOrReturn(defaultValue))
  );
  const [selectedPerson, setSelectedPerson] = useState(
    index !== -1 ? data[index].name : ""
  );

  const [xClicked, setXClicked] = useState(false);
  const [_data, setData] = useState(data);
  const [filteredPeople, setFilteredPeople] = useState([]);
  const currentFieldsFromStore = useSelector((state) => state.showFields);
  const mergeFieldsByName = (base, override) => {
    if (!Array.isArray(base) && !Array.isArray(override)) return [];
    if (!Array.isArray(override) || override.length === 0) return base || [];
    if (!Array.isArray(base) || base.length === 0) return override || [];
    const byName = new Map();
    base.forEach((f) => {
      if (f && f.name) byName.set(f.name, f);
    });
    override.forEach((f) => {
      if (f && f.name) byName.set(f.name, f);
    });
    return Array.from(byName.values());
  };
  const currentFields = mergeFieldsByName(
    currentFieldsFromStore,
    currentFieldsOverride
  );
  const [valueLazyloaded, setValueLazyloaded] = useState({
    previousValue: null,
    changed: false,
  });

  const getExludeId = async (url) => {
    const resp = await getFromAPI(config, url);
    return resp;
  };

  const initFilteredPeople = async (query, data) => {
    let tempData = [];

    if (query === "") {
      tempData = data;
    }

    tempData = data.filter((person) => {
      if (person.name)
        return person.name?.toLowerCase().includes(query?.toLowerCase());

      return false;
    });

    if (Array.isArray(data) && exclude?.param) {
      if (exclude.lazyload?.lazyloadurl && exclude.lazyload?.lazyloadParam) {
        const addDriver = await getExludeId(exclude.lazyload.lazyloadurl);
        if (Array.isArray(addDriver?.data) && addDriver?.data?.length > 0) {
          const checkAgainst = extractFromObject(
            addDriver.data[0],
            exclude.lazyload.lazyloadParam
          );
          if (checkAgainst) {
            tempData = data.filter((x) => x[exclude.param] !== checkAgainst);
          }
        }
      } else {
        tempData = data.filter((x) => x[exclude.param] !== exclude.value);
      }
    }

    return tempData;
  };
  const getFilters = () => {
    let _filters = "";

    if (filters && currentFields) {
      _filters = addFilters(currentFields, filters);
    }
    if (removeElementIfPreviouslyAdded === true && fieldParentName != null) {
      const parentDefault = currentFields.find(
        (x) => x.name === fieldParentName
      ).defaultValue;

      if (parentDefault != null) {
        const values = [];

        parentDefault.forEach((value) => {
          if (
            (value.changed != null ** value.changed) === true &&
            value.delete === true
          ) {
            return;
          } else {
            values.push(value[name].id);
          }
        });
        _filters += `exceptId=${JSON.stringify(values)}&`;
      }
    }
    return _filters;
  };
  useEffect(() => {
    if (
      (lazyloadUrl && selectedPerson != null) ||
      // stopRefetchingOnChange === true ||
      (refetchOnSave === true && isSaving === true)
    ) {
      async function fetchData() {
        try {
          // Perform an async operation, e.g., an API call.
          setIsLoading(true);

          const resp = await fetchDataToDropDown(
            config,
            lazyloadUrl,
            lazyloadParam,
            lazyloadParam2,
            concat,
            concatBy,
            getFilters(),
            lazyloadParamName,
            returnDataAsIs,
            lazyloadParam3,
            nameTransformer
          );

          if (resp) {
            const index = resp.findIndex(
              (field) =>
                field.name === defaultValue ||
                field.id === defaultValue ||
                field.id === defaultValue?.id
            );
            if (editId == null && defaultOnNew != null) {
              const onNewDefaultIndex = resp.findIndex((field) => {
                return field.name === defaultOnNew;
              });

              setSelectedPerson(
                onNewDefaultIndex !== -1 ? resp[onNewDefaultIndex].name : null
              );
              const _e = {
                target: {
                  name: name,
                  value: resp[onNewDefaultIndex].name,
                },
              };
              handleChange(_e);
            } else {
              setSelectedPerson(index !== -1 ? resp[index].name : null);
            }
            setData(resp);

            setFilteredPeople(
              query === ""
                ? resp
                : resp.filter((person) => {
                    return person.name
                      ?.toLowerCase()
                      .includes(query?.toLowerCase());
                  })
            );
            setIsLoading(false);
          } else {
            setIsLoading(false);
          }
        } catch (error) {
          // Handle errors, if any.
          // alert(error);
          console.error(error, "errrrrrrr");
        }
      }
      if (xClicked === false) {
        fetchData();
        if (setIsSaving != null) {
          setIsSaving(false);
        }
      }
    }
  }, [isSaving]);

  useEffect(() => {
    const fetchFilteredPeople = async () => {
      try {
        const result = await initFilteredPeople(query, _data);
        setFilteredPeople(result);
      } catch (error) {
        console.error("Error fetching filtered people:", error);
      }
    };

    fetchFilteredPeople();
  }, [_data, query]);

  useEffect(() => {
    const index = _data.findIndex(
      (field) =>
        field.name ===
          (typeof defaultValue === "object"
            ? defaultValue?.name
            : defaultValue) ||
        field.id ===
          (typeof defaultValue === "object"
            ? defaultValue?.id
            : parseOrReturn(defaultValue))
    );
    setSelectedPerson(index !== -1 ? _data[index].name : "");
    //setData(data);
  }, [defaultValue]);

  useEffect(() => {
    if (
      data &&
      (lazyloadUrl === undefined || lazyloadUrl === "" || lazyloadUrl === null)
    ) {
      setData(data);
    }
    if (Array.isArray(data) && data.length > 0 && defaultValue) {
      const index = data.findIndex(
        (field) =>
          field.name ===
            (typeof defaultValue === "object"
              ? defaultValue?.name
              : defaultValue) ||
          field.id ===
            (typeof defaultValue === "object"
              ? defaultValue?.id
              : parseOrReturn(defaultValue))
      );
      if (index !== -1) {
        setSelectedPerson(data[index].name);
        //inputChanged({ id: data[index].id, name: data[index].name})
      }
    }
  }, [data]);

  const inputChanged = (e) => {
    const _e = {
      target: {
        name: name,
        value:
          e && (e.id || e.name)
            ? returnObject
              ? e
              : returnID
              ? e?.id
              : e?.name
            : "",
      },
    };

    setSelectedPerson(e?.name);
    handleChange(_e);
    setQuery("");
  };

  useEffect(() => {
    if (defaultsTo && typeof defaultsTo === "string") {
      const mainParam = defaultsTo.split(".")[0];
      const searchParam = defaultsTo.split(".").splice(1).join(".");
      let defaultToValue;
      if (mainParam) {
        const paramIndex = currentFields.findIndex((x) => x.name === mainParam);
        if (paramIndex !== -1) {
          if (currentFields[paramIndex].changed === true) {
            if (currentFields[paramIndex].defaultValue) {
              if (Array.isArray(currentFields[paramIndex].data)) {
                if (
                  typeof currentFields[paramIndex].defaultValue !== "object"
                ) {
                  const searchBy =
                    parseInt(currentFields[paramIndex].defaultValue) || -1;
                  const dataNeededIndex = currentFields[
                    paramIndex
                  ].data.findIndex((x) => x.id === searchBy);
                  if (dataNeededIndex !== -1) {
                    const searchObject = {
                      ...currentFields[paramIndex].data[dataNeededIndex],
                    };
                    defaultToValue = extractFromObject(
                      searchObject,
                      searchParam
                    );
                  }
                }
              } else {
                if (
                  typeof currentFields[paramIndex].defaultValue === "object"
                ) {
                  defaultToValue = extractFromObject(
                    currentFields[paramIndex].defaultValue,
                    searchParam
                  );
                  if (+defaultToValue) {
                    defaultToValue = +defaultToValue;
                  }
                }
              }
            }
          }
        }
      }
      const currentDefault = currentFields.find(
        (x) => x.name === name
      )?.defaultValue;
      if (defaultToValue && currentDefault !== defaultToValue) {
        const index = _data.findIndex(
          (field) =>
            field.name ===
              (typeof defaultToValue === "object"
                ? defaultToValue?.name
                : defaultToValue) ||
            field.id ===
              (typeof defaultToValue === "object"
                ? defaultToValue?.id
                : parseOrReturn(defaultToValue))
        );
        if (index !== -1) {
          const _e = {
            target: {
              name: name,
              value: returnObject
                ? _data[index]
                : returnID
                ? _data[index].id
                : _data[index].name,
            },
          };

          setSelectedPerson(_data[index].name);
          handleChange(_e);
        }
      }
    }

    if (lazyloadUrl && filters) {
      setValueLazyloaded((prev) => {
        return { ...prev, changed: true };
      });
    }
  }, [currentFields]);

  const RefetchData = () => {
    //Reload if filter Related
    if (lazyloadUrl && filters) {
      async function fetchData() {
        try {
          // Perform an async operation, e.g., an API call.
          setIsLoading(true);
          const resp = await fetchDataToDropDown(
            config,
            lazyloadUrl,
            lazyloadParam,
            lazyloadParam2,
            concat,
            concatBy,
            getFilters(),
            lazyloadParamName,
            undefined,
            lazyloadParam3,
            nameTransformer
          );
          if (resp) {
            const index = resp.findIndex(
              (field) =>
                field.name === defaultValue ||
                field.id === defaultValue ||
                field.id === defaultValue?.id
            );
            setSelectedPerson(index !== -1 ? resp[index].name : "");
            setData(resp);
            setIsLoading(false);
            setFilteredPeople(
              query === ""
                ? resp
                : resp.filter((person) => {
                    return person.name
                      ?.toLowerCase()
                      .includes(query?.toLowerCase());
                  })
            );
            if (index === -1) {
              clearSelection();
            }
          } else {
            setData([]);
            setIsLoading(false);
            setFilteredPeople([]);
            clearSelection();
          }
        } catch (error) {
          // Handle errors, if any.
          alert(error);
        }
      }

      fetchData();
      console.log("refetching data");
    }
  };

  useEffect(() => {
    if (valueLazyloaded.changed) {
      if (Array.isArray(lazyloadFieldChange) && currentFields) {
        let flag = false;
        let currentValues = valueLazyloaded.previousValue || {};
        for (const i in lazyloadFieldChange) {
          let f = lazyloadFieldChange[i];
          const findRelatedField = currentFields.find(
            (x) => x.name === f && x.changed === true
          );

          if (
            findRelatedField &&
            !Array.isArray(findRelatedField?.defaultValue) &&
            currentValues[f] !== findRelatedField?.defaultValue
          ) {
            currentValues = {
              ...currentValues,
              [f]: findRelatedField.defaultValue,
            };
            flag = true;
          }
        }

        if (flag) {
          setValueLazyloaded({ changed: false, previousValue: currentValues });
          RefetchData();
        }
      }
    }
  }, [valueLazyloaded]);

  const addNewClicked = (e) => {
    if (handleCreate instanceof Function) {
      handleCreate(name);
    }
  };

  const clearSelection = () => {
    setXClicked(true);
    inputChanged({ id: "", name: "" });
    // Force parent form to see empty value for required validation
    handleChange({ target: { name, value: "" } });
  };
  let isFieldDisabled =
    disabledIfField != null
      ? disabled ||
        disabledIfFieldChecker(currentFields, {
          field: disabledIfField.field,
          valuesArray: disabledIfField.isEqual,
        })
      : disabled ?? false;

  if (actionType != null && disableOnAction != null) {
    if (disableOnAction === actionType) {
      isFieldDisabled = true;
    }
  } else if (
    disableEditForNonAdmin != null &&
    disableEditForNonAdmin === true &&
    currentRole !== process.env.REACT_APP_ADMIN_ROLE &&
    formType === "edit"
  ) {
    isFieldDisabled = true;
  }
  return (
    <>
      {displayTextOnly === true ? (
        <div>
          <label className="block text-sm font-medium leading-6 text-gray-900 text-left">
            {label}
            {required ? "*" : ""}
          </label>
          <div className="block text-sm font-medium leading-6 text-[#6b7280] text-left">
            {selectedPerson}
          </div>
        </div>
      ) : (
        <>
          <Combobox
            as="div"
            value={selectedPerson}
            onChange={inputChanged}
            name={name}
            id={id}
            disabled={
              isFieldDisabled || _data.length === 0 || isLoading === true
            }
            className={hide ? "hidden" : ""}
          >
            <Combobox.Label className="block text-sm font-medium leading-6 text-gray-900 text-left">
              {label}
              {required ? "*" : ""}
              {addNew && (
                <div
                  onClick={addNewClicked}
                  className="float-end cursor-pointer text-blue-700 hover:text-blue-500"
                  style={{ float: "inline-end" }}
                >
                  <PlusIcon
                    className="float-start w-5 mt-0.5"
                    style={{ float: "inline-start" }}
                  />{" "}
                  New
                </div>
              )}
            </Combobox.Label>
            <div className="relative mt-2">
              {isLoading === true && (
                <div
                  className="absolute"
                  style={{
                    top: "50%",
                    left: "5%",
                    transform: "translate(-0%,-50%)",
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="animate-spin"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    width="24"
                    height="24"
                    strokeWidth="2"
                  >
                    <path d="M12 3a9 9 0 1 0 9 9"></path>{" "}
                  </svg>
                </div>
              )}
              <Combobox.Input
                className={classNames(
                  err
                    ? "text-red-900 ring-red-300 placeholder:text-red-300 focus:ring-2 focus:ring-inset focus:ring-red-500"
                    : "",
                  "w-full rounded-md border-0 bg-white py-1.5 pl-3 pr-10 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6 disabled:cursor-not-allowed disabled:bg-gray-50 disabled:text-gray-500 disabled:ring-gray-200"
                )}
                onChange={(event) => setQuery(event.target.value)}
                displayValue={selectedPerson?.name}
                placeholder={placeholder || "Select an Option"}
                autoComplete="off"
                readOnly={isFieldReadOnly}
              />
              {(disableXButton == null || disableXButton !== true) &&
                selectedPerson &&
                !isFieldDisabled && (
                  <div className="absolute inset-y-0 right-4 pr-3 flex items-center">
                    <button
                      type="button"
                      className="text-gray-400 hover:text-white bg-primary rounded-full"
                      onClick={() => {
                        clearSelection();
                        // setXClicked(false);
                      }}
                    >
                      <XMarkIcon className="h-5 w-5" aria-hidden="true" />
                    </button>
                  </div>
                )}
              <Combobox.Button
                onBlur={() => {
                  setQuery("");
                }}
                onClick={(e) => {
                  e.stopPropagation();
                }}
                className="absolute inset-y-0 right-0 flex items-center rounded-r-md pr-2 focus:outline-none"
              >
                <ChevronUpDownIcon
                  className={`h-5 w-5 text-gray-400 ${
                    disabled ? "hidden" : ""
                  }`}
                  aria-hidden="true"
                />
              </Combobox.Button>

              {filteredPeople.length > 0 && (
                <Combobox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                  {filteredPeople.map((person) => (
                    <Combobox.Option
                      key={person.id}
                      value={person}
                      style={{
                        backgroundColor:
                          person.name === selectedPerson && "#4f46e5",
                        color: person.name === selectedPerson ? "#fff" : "#000",
                      }}
                      className={({ active }) =>
                        classNames(
                          "relative cursor-default select-none py-2 pl-3 pr-9",
                          active ? "bg-[#eee] text-white" : "text-gray-900"
                        )
                      }
                    >
                      {({ active, selected }) => (
                        <>
                          <span
                            className={classNames(
                              "block truncate text-left",
                              selected && "font-semibold"
                            )}
                          >
                            {`${
                              person.name.includes("-") &&
                              person.name.split("-")[0].trim().length === 3
                                ? "✈"
                                : ""
                            } ${person.name}`}
                          </span>

                          {selected && (
                            <span
                              className={classNames(
                                "absolute inset-y-0 right-0 flex items-center pr-4",
                                active ? "text-white" : "text-blue-600"
                              )}
                            >
                              <CheckIcon
                                className="h-5 w-5"
                                aria-hidden="true"
                              />
                            </span>
                          )}
                        </>
                      )}
                    </Combobox.Option>
                  ))}
                </Combobox.Options>
              )}
            </div>
          </Combobox>
          {err && <p className="text-left mt-2 text-sm text-red-600">{err}</p>}
        </>
      )}
    </>
  );
}

export default InputDropDown;
